export default {
	/**
	 * 导航栏
	 */
	NAV_ABOUT: 'About us',
	NAV_NEWS: 'News Center',
	NAV_ACADEMIC: 'Programmes',
	NAV_CHARACTER: 'People',
	NAV_PUBLICATION: 'Publications',
	NAV_IMAGE: 'Multimedia',
	NAV_ANNOUNCEMENT: 'Announcements',
	NAV_REGISTRATION: 'E-CONFERENCE',
	NAV_DOWNLOAD: 'DownLoad PDF',
	/**
	 * 按钮
	 */
	BUTTON_NEXT: 'Confirm',
	BUTTON_PREV: 'Prev',
	BUTTON_SKIP: 'Skip',
	BUTTON_AGREE: 'Agree and continue',
	/**
	 * 登录
	 */
	LOGIN_BTN: 'Log in',
	LOGIN_TITLE: 'Login',
	LOGIN_INPUT_NAME_PLACEHOLDER: 'Please input your email',
	LOGIN_INPUT_PWD_PLACEHOLDER: 'Please input your password',
	LOGIN_FORGET_PWD: 'Forgot Password',
	LOGIN_ERROR: 'The account does not exist or the password is incorrect. Please re-enter',
	/**
	 * 忘记密码
	 */
	FORGET_GUIDE: 'Please enter your email address for password reset',
	FORGET_GUIDE2: 'Password sent to mailbox',
	FORGET_GUIDE3: 'Sent to your registered email address',
	FORGET_GUIDE4: 'Please check the mail and follow the prompts',
	/**
	 * 重置密码
	 */
	RESET_PWD: 'Reset Password',
	RESET_GUIDE: 'Please enter a new password for password reset.12 to 20 characters,contains numbers,uppercase letters,lowercase letters and symbols',
	RESET_NEW_PWD: 'Please enter a new password',
	RESET_NEW_PWD_AGAIN: 'Please enter your new password again',
	RESET_SAVE: 'Save and Log in',
	RESET_NOT_EQUAL: 'Inconsistent password entered twice',
	RESET_PASSWORD_INVALID: '12 to 20 characters,contains numbers,uppercase letters,lowercase letters and symbols',
	/**
	 * 进度
	 */
	PROGRESS_1: 'Basic Information',
	PROGRESS_2: 'Activity',
	PROGRESS_3: 'Flight',
	PROGRESS_4: 'Accommodation',
	PROGRESS_5: 'Successful!',
	PROGRESS_6: 'Documents',
	/**
	 * 基本信息
	 */
	INFORMATION_TITLE: 'Basic Information',
	INFORMATION_GUIDE1: 'Items marked with ',
	INFORMATION_GUIDE2: ' must be filled out',
	INFORMATION_GUIDE3: 'Remarks: Shanghai Forum is an invitation-only forum, please complete the meeting registration as soon as possible to confirm the participation.',
	INFORMATION_LEFT1_LABEL: 'Last Name',
	INFORMATION_LEFT1_TIP: 'Please enter your last name',
	INFORMATION_LEFT2_LABEL: 'Gender',
	INFORMATION_LEFT2_TIP: 'Please select your gender',
	INFORMATION_LEFT2_OPTION1: 'Male',
	INFORMATION_LEFT2_OPTION2: 'Female',
	INFORMATION_LEFT2_OPTION3: 'Other',
	INFORMATION_LEFT3_LABEL: 'Date of Birth',
	INFORMATION_LEFT4_LABEL: 'Affiliation',
	INFORMATION_LEFT4_TIP: 'Please enter your affiliation',
	INFORMATION_LEFT5_LABEL: 'Telephone Number',
	INFORMATION_LEFT5_TIP: 'Please enter your telephone number',
	INFORMATION_LEFT6_LABEL: 'Assistant name',
	INFORMATION_LEFT6_TIP: 'Please enter assistant name (optional)',
	INFORMATION_LEFT7_LABEL: 'Assistant\'s number',
	INFORMATION_LEFT7_TIP: 'Please enter assistant\'s contact number (optional)',
	INFORMATION_RIGHT1_LABEL: 'First Name',
	INFORMATION_RIGHT1_TIP: 'Please enter your first name',
	INFORMATION_RIGHT2_LABEL: 'Country/Region',
	INFORMATION_RIGHT2_TIP: 'Please select Country',
	INFORMATION_RIGHT3_LABEL: 'Passport Number',
	INFORMATION_RIGHT3_TIP: 'Please enter your passport number',
	INFORMATION_RIGHT4_LABEL: 'Position',
	INFORMATION_RIGHT4_TIP: 'Please enter your position',
	INFORMATION_RIGHT5_LABEL: 'Contact Address',
	INFORMATION_RIGHT5_TIP: 'Please enter your contact address (optional)',
	INFORMATION_RIGHT6_LABEL: 'Assistant\'s email',
	INFORMATION_RIGHT6_TIP: 'Please enter assistant\'s email (optional)',
	INFORMATION_BIRTHDAY_TIP: 'Please select date of birth',
	/**
	 * 活动安排
	 */
	ACTIVITY_TITLE: 'Activity Arrangement',
	ACTIVITY_NO_ACCESS: 'The event is only open to some guests. Please contact the secretariat office for more information.',
	ACTIVITY_NO_SELECT: 'No activities have been selected',
	ACTIVITY_FAV: 'Please select the event you are interested in',
	/**
	 * 航班信息
	 */
	FLIGHT_TITLE: 'Flight Information',
	FLIGHT_DEADLINE: 'Apr. 15th',
	FLIGHT_GUIDE1: 'You can book your ticket in one of four ways. (not multiple choices)',
	FLIGHT_GUIDE2: '1. Please fill in the flight information before ',
	FLIGHT_GUIDE3: ' if you require our agency to book a ticket. Otherwise, please purchase the ticket  first and fill in the reimbursement information. ',
	FLIGHT_GUIDE4: '2. If you choose high-speed train, the organizing committee will not provide the agency ticket purchase service. You can purchase the ticket yourself, and the organizing committee will reimburse you the ticket fee according to the financial regulation of the country.',
	FLIGHT_SECTION_TITLE1: 'Require Shanghai Forum Conference Agency to book a ticket',
	FLIGHT_SECTION_TITLE2_PRE: 'Buy Your own ticket and request cash',
	FLIGHT_SECTION_TITLE2_STRONG: '(RMB)',
	FLIGHT_SECTION_TITLE2_AFTER: ' reimbursement during on-site registration',
	FLIGHT_SECTION_TITLE3: 'Buy Your own ticket and request reimbursement via bank transfer',
	FLIGHT_SECTION_TITLE4: 'Buy your own ticket without reimbursement',
	FLIGHT_GO_TITLE: 'Departure Information',
	FLIGHT_GO_LABEL1: 'Please confirm the departure city',
	FLIGHT_GO_LABEL2: 'Please confirm the departure date',
	FLIGHT_GO_LABEL3: 'Specify the departure flight no.',
	FLIGHT_RETURN_TITLE: 'Return Information',
	FLIGHT_RETURN_LABEL1: 'Please confirm the return destination',
	FLIGHT_RETURN_LABEL2: 'Please confirm the return date',
	FLIGHT_RETURN_LABEL3: 'Specify the return flight no.',
	FLIGHT_ATTENTION0: 'Note:',
	FLIGHT_ATTENTION1: 'If you need to book an international flight, please fill in the passport number and upload a scanned copy of your passport photo page',
	FLIGHT_ATTENTION2: 'If you need to use a passport number to book a domestic flight, please make sure to fill in the passport number and upload a scanned copy of your passport photo page',
	FLIGHT_ATTENTION3: 'The forum only undertakes round-trip air tickets or high-speed rail tickets between the guest\'s location and the conference venue (Shanghai). The visa fee, taxi fare to and from the airport/train station will not be borne.',
	FLIGHT_WARN: 'After the ticket is confirmed to be issued, if there is no special circumstances, the refund fee and the fee for the change due to the guest\'s own reasons shall be borne by the guests themselves.',
	FLIGHT_UPLOAD1: 'Click to add a passport photo page',
	FLIGHT_UPLOAD2: 'Click to add an e-ticket itinerary',
	FLIGHT_CASH_GUIDE1: 'You can purchase a round-trip/one-way ticket yourself. If you need to book a one-way ticket, please send an email to shanghaiforum@fudan.edu.cn .',
	FLIGHT_CASH_GUIDE2: 'If you choose RMB cash reimbursement, please upload your e-ticket itinerary in time after purchase, and the forum will reimburse according to the price on the electronic itinerary, if do not exceed the reimbursement limit. Please submit your original boarding pass and ID card/passport copy to the staff at the forum registration site to apply for reimbursement.',
	FLIGHT_CASH_GUIDE3: 'The forum only bears the cost of round-trip economy class airfare (excluding super economy class). If you purchase other classes yourself, you need to provide the same economy class quotation when you purchase the ticket. Within the reimbursement limit, you will be reimbursed with reference to the economy class quotation amount.',
	FLIGHT_CASH_GUIDE4: 'Airfare reimbursement limit:',
	FLIGHT_CASH_GUIDE41_PRE: '1) China\'s domestic (including Hong Kong, Macao and Taiwan) reimbursement limit is ',
	FLIGHT_CASH_GUIDE41_CONTENT: 'RMB ￥3000',
	FLIGHT_CASH_GUIDE41_AFTER: '(round trip)',
	FLIGHT_CASH_GUIDE42_PRE: '2) Asia\'s reimbursement limit is ',
	FLIGHT_CASH_GUIDE42_CONTENT: 'RMB ￥6000 ',
	FLIGHT_CASH_GUIDE42_AFTER: '(round trip)',
	FLIGHT_CASH_GUIDE43_PRE: '3) Reimbursement limit for other regions is',
	FLIGHT_CASH_GUIDE43_CONTENT: 'RMB ￥12000',
	FLIGHT_CASH_GUIDE43_AFTER: '(round trip)',
	FLIGHT_TRANSFER_GUIDE2: 'If you choose bank transfer reimbursement, please upload your e-ticket itinerary and fill in the transfer information below after purchasing the ticket. The reimbursement will be made based on the price on the electronic itinerary. Please submit your original boarding pass and ID card/passport copy to the staff at the forum registration site for reimbursement.',
	FLIGHT_ALERT: 'Please agree the terms below remarks',
	FLIGHT_START: 'start time',
	FLIGHT_END: 'end time',
	FLIGHT_NO: 'Specify flight no',
	FLIGHT_SPAN: 'Choose Period',
	FLIGHT_TIME_COMPARE: 'Start time cannot be later than end time',
	/**
	 * 酒店信息
	 */
	HOTEL_TITLE: 'Hotel Information',
	HOTEL_SUBTITLE: 'The conference group will book a room for you at the designated hotel of the forum',
	HOTEL_GUIDE1: 'To ensure that there are available rooms at the hotel, please fill in your accommodation information before ',
	HOTEL_GUIDE2: ' .',
	HOTEL_GUIDE3: 'Apr. 15th',
	HOTEL_GUIDE4: 'Shanghai Forum only reserve one room by default, if you have any questions, please contact us.',
	HOTEL_GUIDE5: 'The Forum will bear accommodation costs (including only breakfast) for guests for most 4 nights (May 8-11). Additional accommodation or other expenses will be settled by you upon your check-out.',
	HOTEL_GUIDE6: 'The Forum can reserve hotel rooms for guests who pay their own expense. You can settle your bills upon check-out;',
	HOTEL_GUIDE7: '\tHotel departure deadline and credit-card pre-authorization, etc. should be based on the hotel\'s relevant articles of association.',
	HOTEL_LABEL1: 'Please select hotel check-in date',
	HOTEL_LABEL2: 'Please select hotel check-out date',
	HOTEL_LABEL3: 'Remarks',
	HOTEL_LABEL4: 'Please note for other special requirements',
	HOTEL_LABEL5: 'Check in',
	HOTEL_LABEL6: 'Check out',
	HOTEL_TIP: 'Departure date cannot be earlier than check-in date',
	/**
	 * 与会文件
	 */
	DOCUMENT_TITLE: 'Participation Documents',
	DOCUMENT_DEADLINE: 'May 01, 2020',
	DOCUMENT_GUIDE2: 'The organizing committee will sort out the abstracts and papers you have uploaded, as meeting materials, and will be distributed to all guests during the forum;',
	DOCUMENT_GUIDE3: 'The organizing committee will sort out the abstracts, papers and contents of your public speeches that you have uploaded, and may post them on non-profit platforms such as the forum\'s official website, and may conduct non-profit publications;',
	DOCUMENT_GUIDE4: 'The forum will be entirely videoed, and the related photos and video content will be publicly released on the non-profit platform such as the forum\'s official website;',
	DOCUMENT_GUIDE5: 'By default, the Forum Organizing Committee agrees to the publication and publication of all the above contents. If you have any questions,send an email to shanghaiforum@fudan.edu.cn;',
	DOCUMENT_GUIDE6: 'Please fill in the topic in time, upload the forum, summary of the speech and the speech PPT in English or both in English and Chinese to help the preparation of the meeting. Thank you for your support!',
	DOCUMENT_LABEL1: 'Speech topic',
	DOCUMENT_TIP1: 'Please fill in your topic',
	DOCUMENT_SECTION_TITLE1: "Upload Paper",
	DOCUMENT_SECTION_TITLE2: "Upload Summary",
	DOCUMENT_SECTION_TITLE3: "Upload Speech PPT",
	DOCUMENT_REQUIREMENTS_TITLE1: 'Paper requirements',
	DOCUMENT_REQUIREMENTS_TITLE2: 'Summary requirement',
	DOCUMENT_REQUIREMENTS_TITLE3: 'Speech PPT requirements',
	DOCUMENT_REQUIREMENTS1: 'The paper should be in English or Chinese;',
	DOCUMENT_REQUIREMENTS1_SUMMARY: ' The summary should be in English or Chinese;',
	DOCUMENT_REQUIREMENTS1_PPT: 'The PPT should be in English or both in English and Chinese',
	DOCUMENT_REQUIREMENTS2: 'Must contain abstracts and keywords;',
	DOCUMENT_REQUIREMENTS3: 'Word count (including abstract): no less than 5,000 words in Chinese, no less than 3,000 words in English;',
	DOCUMENT_REQUIREMENTS4: 'The paper needs to be closely related to the theme of the sub-forum and showcase your latest insights into the topic;',
	DOCUMENT_REQUIREMENTS5: 'The format of the uploaded file must be .doc, .docx or .pdf, and the file size must be less than 10M.',
	DOCUMENT_REQUIREMENTS5_1: 'The format of the uploaded file must be .doc, .docx, and the file size must be less than 10M.',
	DOCUMENT_REQUIREMENTS6: 'It should be a brief summary of your presentation;',
	DOCUMENT_REQUIREMENTS7: 'Word count: 500 words in Chinese; 300 words in English;',
	DOCUMENT_REQUIREMENTS8: 'The Forum Organizing Committee will publish the “Collection of Abstracts/Papers”, which will be distributed to all the chairmen and guests during the forum;',
	DOCUMENT_REQUIREMENTS9: 'The content is the PPT you need to use when you speak;',
	DOCUMENT_REQUIREMENTS10: 'Uploading a PPT in advance can help improve the quality of on-site simultaneous interpretation and improve the quality of conference discussions. If you cannot upload it in advance, you need to copy it on the spot. Please send an email to shanghaiforum@fudan.edu.cn to inform the organizing committee in advance;',
	DOCUMENT_REQUIREMENTS11: 'The format of the uploaded file must be .ppt, .pptx or .pdf, and the file size must be less than 20M.',
	DOCUMENT_NOT_SUPPORT: 'Current file format not supported',
	DOCUMENT_DIALOG_TITLE: 'Notice',
	DOCUMENT_DIALOG_CONTENT1: '1.The abstracts and papers you have uploaded will be sorted out as meeting materials and be distributed to all the guests during the forum;',
	DOCUMENT_DIALOG_CONTENT2: '2.The abstracts, papers and your public speeches may be posted on non-profit platforms such as the forum\'s official website, and may be included in non-profit publications;',
	DOCUMENT_DIALOG_CONTENT3: '3.The forum will be entirely videotaped. The photos and videos will be publicly released on non-profit platforms such as the forum\'s official website;',
	DOCUMENT_DIALOG_CONTENT4: 'Delegates not wishing to have their abstracts, papers, public speeches or presentation videos published may raise their concerns to the Shanghai Forum Organizing Committee via shanghaiforum@fudan.edu.cn before the forum. ',
	DOCUMENT_DIALOG_CONTENT5: 'Thank you for your understanding and support.',
	DOCUMENT_DIALOG_BUTTON: 'Confirm',
	/**
	 * 汇总页
	 */
	SUMMARY_EDIT: 'Edit',
	SUMMARY_PAPER: 'Paper',
	SUMMARY_ABSTRACT: 'Abstract',
	SUMMARY_CHECK_IN: 'Check in',
	SUMMARY_CHECK_OUT: 'Check out',
	SUMMARY_FLIGHT1: 'Departure information',
	SUMMARY_FLIGHT1_1: 'Departure city',
	SUMMARY_FLIGHT1_2: 'Departure date',
	SUMMARY_FLIGHT2: 'Return information',
	SUMMARY_FLIGHT2_1: 'Return city',
	SUMMARY_FLIGHT2_2: 'Return date',
	SUMMARY_FLIGHT_NO: 'Flight number',
	SUMMARY_FLIGHT_OWN: 'Buy your own ticket without reimbursement',
	SUMMARY_CONFIRM: 'Please complete the editing of the basic information first.',
	SUMMARY_CONFIRM_OK: 'Edit basic information',
	SUMMARY_ITINERARY: 'E-ticket itinerary',
	/**
	 * 通用
	 */
	NEXT: 'Next',
	TIP_WAITING: 'Please wait...',
	TIP_EMAIL_WRONG: 'The email is incorrect',
	TIP_EMAIL_REQUIRED: 'Please enter email',
	TIP_PWD_REQUIRED: 'Please enter password',
	TIP_OVER_SIZE: 'The selected file size exceeds the limit, please re-select',
	TIP_OVER_SIZE2: 'The file size must be less than 20M',
	TIP_NOT_FILLED: 'Not filled',
	TIP_REQUIRED: 'Please fill in this item',
	TIP_CHANGE_PASSWORD: ' Change Password',
	TIP_LOGOUT: 'Logout',
	TIP_PROTOCOL: 'Service agreement',
	TIP_CANCEL: 'Cancel',
	TIP_CONFIRM: 'Confirm',
	TIP_DELETE: 'Whether to confirm deletion?',
	TIP_DELETE_YES: 'Yes',
	TIP_DELETE_NO: 'No',
	/**
	 * 悬浮菜单
	 */
	SIDE_MENU_BOOK: 'Conference Programme',
	SIDE_MENU_GUIDE: 'Conference Guide',
	SIDE_MENU_QA: 'FAQ',
	SIDE_MENU_VISA: 'Visa Invitation'
};
